import axios from 'axios';
import {
    AUTH_REQUEST,
    AUTH_ERROR,
    AUTH_SUCCESS,
    AUTH_LOGOUT,
    AUTH_REFRESH,
    USER_REQUEST,
    OVERRIDE,
    AUTH_LOGINAS,
    AUTH_RETURNAS,
} from '../actions';

const state = {
    token: localStorage.getItem('access-token') || '',
    status: '',
    hasLoadedOnce: false,
    override_id: null,
    override_endpoints: [],
    override_permission: null,
};

const getters = {
    isAuthenticated: state => !!state.token,
    authState: state => state.status,
    overrideID: state => state.override_id,
    overideEndpoints: state => state.override_endpoints,
    overridePermission: state => state.override_permission,
};

const actions = {
    [AUTH_REQUEST]: ({commit, dispatch}, credentials) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios.post('/login', credentials).then(res => {
                const access_token = res.data.auth.access_token;

                localStorage.setItem('access-token', access_token);

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;

                commit(AUTH_SUCCESS, access_token);
                dispatch(USER_REQUEST, res.data.profile);
                resolve(res);
            }).catch(err => {
                commit(AUTH_ERROR, err);
                localStorage.removeItem('access-token');
                reject(err);
            });
        });
    },
    [AUTH_LOGINAS]: ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios.post('/loginAs/' + user).then(res => {
                if (res.data.success != true) {
                    throw new Error("Invalid state, " + res.data.message);
                }
                //commit(AUTH_SUCCESS, access_token);
                dispatch(USER_REQUEST, res.data.profile);
                resolve(res);
            }).catch(err => {
                commit(AUTH_ERROR, err);
                reject(err);
            });
        });
    },
    [AUTH_RETURNAS]: ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            axios.post('/endLoginAs/').then(res => {

                //commit(AUTH_SUCCESS, access_token);
                dispatch(USER_REQUEST, res.data.profile);
                resolve(res);
            }).catch(err => {
                commit(AUTH_ERROR, err);
                reject(err);
            });
        });
    },
    [AUTH_REFRESH]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            let axiosUse = axios.create(); //this keeps refresh (when it fails) from ending up in a refresh loop
            axiosUse.post('/login/refresh').then(res => {
                try {
                    console.log(res);
                    const access_token = res.data.access_token;

                    localStorage.setItem('access-token', access_token);

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;

                    commit(AUTH_SUCCESS, access_token);
                    console.log(res.data);
                    //dispatch(USER_REQUEST, res.data.profile);
                    resolve(res);
                } catch (err) {
                    reject(err);
                }
            }).catch(err => {
                console.log("AUTH ERROR");
                commit(AUTH_ERROR);
                localStorage.removeItem('access-token');
                reject(err);
            });
        });
    },
    [AUTH_LOGOUT]: ({commit}) => {
        console.log("commit for logout started");
        commit(AUTH_LOGOUT);
        return new Promise((resolve, reject) => {
            console.log('promise start', axios);
            //let axiosUse = axios.create();
            axios.post('/logout').then(() => {
                localStorage.removeItem('access-token');
                delete axios.defaults.headers.common['Authorization'];

                resolve();
            }).catch(() => {
                localStorage.removeItem('access-token');
                delete axios.defaults.headers.common['Authorization'];
                reject();
            }).finally(() => { });
            console.log('promise edge');
        });
    },
};

const mutations = {
    [AUTH_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [AUTH_SUCCESS]: (state, access_token) => {
        state.status = 'success';
        state.token = access_token;
        state.hasLoadedOnce = true;
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
    },
    [AUTH_LOGOUT]: (state) => {
        state.token = '';
        state.status = '';
    },
    [OVERRIDE]: (state, overrider) => {
        if (overrider) {
            state.override_endpoints = overrider.endpoints;
            state.override_id = overrider.id;
            state.override_permission = overrider.permission;
        } else {
            state.override_id = null;
            state.override_endpoints = [];
            state.override_permission = null;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
